import React from "react";
import { Box, Typography, Container, Grid, IconButton } from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";

function Footer() {
  return (
    <Box sx={{ backgroundColor: "#B3A6D2", py: 4, color: "white" }}>
      <Container maxWidth="lg">
        <Grid container spacing={3} alignItems="center">
          {/* Logo */}
          <Grid item xs={12} sm={3} textAlign="center">
            <img src="/images/logo.png" alt="BisbalGat Logo" style={{ height: 80 }} />
          </Grid>
          
          {/* Informações */}
          <Grid item xs={12} sm={5} textAlign="center">
            <Typography variant="h6" fontWeight="bold">BISBALGAT</Typography>
            <Typography variant="body2">La Bisbal d'Empordà</Typography>
            <Typography variant="body2">Girona</Typography>
            <Box mt={1}>
              <IconButton href="https://www.instagram.com/bisbalgat_oficial/?hl=es" sx={{ color: "white" }}>
                <InstagramIcon />
              </IconButton>
              <IconButton href="https://www.facebook.com/associacio.bisbalgat.adopcions.gats/?locale=es_ES" sx={{ color: "white" }}>
                <FacebookIcon />
              </IconButton>
            </Box>
          </Grid>
          
          
          {/* Copyright */}
          <Grid item xs={12} sm={2} textAlign="center">
            <Typography variant="body2">© BISBALGAT 2025</Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Footer;
